"use client";

import { BlogServices } from "@/services";
import { useParams } from "next/navigation";
import { FormEvent, useRef, useState } from "react";
import toast from "react-hot-toast";

function useCommentSection() {
  const commentRef = useRef<HTMLDivElement | null>(null);
  const params = useParams();
  const slug = params.slug as string;

  const [commentPage, setCommentPage] = useState(1);

  // COMMENTS
  const { data: comments, refetch: refetchComments } =
    BlogServices().useGetBlogComments(slug, commentPage, 5);

  // ADD COMMENT
  const { mutateAsync: addComment, isPending: commentPending } =
    BlogServices().useAddBlogComment();

  // COMMENT FORM
  const [commentPayload, setCommentPayload] = useState({
    name: "",
    email: "",
    comment: "",
  });

  const handleCommentPageChange = (page: number) => {
    setCommentPage(page);

    // SCROLL TO TOP OF COMMENTS WITH OFFSET
    const top =
      (commentRef.current?.getBoundingClientRect().top || 0) +
      window.scrollY -
      120; // increase/decrease this value

    window.scrollTo({
      top,
      behavior: "smooth",
    });
  };

  // SUBMIT COMMENT
  const submitComment = async (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();

    if (
      !commentPayload.name ||
      !commentPayload.email ||
      !commentPayload.comment
    ) {
      toast.error("All fields are required");
      return;
    }

    try {
      await addComment({
        slug,
        ...commentPayload,
      });

      toast.success("Comment added successfully");

      setCommentPayload({
        name: "",
        email: "",
        comment: "",
      });

      refetchComments();
    } catch (error) {
      console.log(error);

      toast.error("Failed to add comment");
    }
  };

  return {
    submitComment,
    setCommentPayload,
    setCommentPage,
    handleCommentPageChange,
    commentRef,
    comments,
    commentPayload,
    commentPending,
  };
}

export default useCommentSection;
